import type { ServiceResponseDto } from '../types/api/service';
import type {
  PracSearchRequestDto,
  PracSearchResponseDto,
  PracCreateRequestDto,
  PracSearchResultDto,
} from '../types/api/pracSearch';
import { BaseServiceClient } from './BaseServiceClient';

/**
 * ProviderAccountService
 *
 * Adapter for the provider_account_search backend operation (sync service).
 *
 * Pass the apiService (ApiService instance) injected via ProGroupsProps.
 */
export class ProviderAccountService extends BaseServiceClient {
  constructor(apiService: any) {
    super(apiService);
  }

  /**
   * Search provider accounts using the provider_account_search endpoint.
   * Returns the full parsed response including paged results and account details.
   */
  async searchAccounts(
    request: PracSearchRequestDto
  ): Promise<PracSearchResponseDto> {
    let response: ServiceResponseDto;
    try {
      response = await this.callService('provider_account_search', request);
    } catch (err: any) {
      throw new Error(
        `provider_account_search failed: ${err?.message ?? 'unknown error'}`
      );
    }

    if (!response.success) {
      throw new Error(
        `provider_account_search error: ${response.message || response.errorDescription}`
      );
    }

    try {
      return JSON.parse(response.payload) as PracSearchResponseDto;
    } catch {
      throw new Error('provider_account_search: failed to parse response payload');
    }
  }

  /**
   * Create a new provider account using the provider_account_create endpoint.
   * Returns the newly created account as PracSearchResultDto.
   */
  async createAccount(
    request: PracCreateRequestDto
  ): Promise<PracSearchResultDto> {
    let response: ServiceResponseDto;
    try {
      response = await this.callService('provider_account_create', request);
    } catch (err: any) {
      throw new Error(
        `provider_account_create failed: ${err?.message ?? 'unknown error'}`
      );
    }

    if (!response.success) {
      throw new Error(
        `provider_account_create error: ${response.message || response.errorDescription}`
      );
    }

    try {
      return JSON.parse(response.payload) as PracSearchResultDto;
    } catch {
      throw new Error('provider_account_create: failed to parse response payload');
    }
  }
}
